import { createAsyncThunk } from "@reduxjs/toolkit";
import { templateAPIs } from "services/api/magnifi/templateAPIs";

// Single exported function that handles the dynamic template requirements
export const fetchDynamicVariables = createAsyncThunk(
  "dynamicTemplateVariable/fetchDynamicVariables",
  async (param, { rejectWithValue }) => {
    try {
      const params = {
        templateId: param.id,
        entityId: param.entity_id,
      };

      // Use templateAPIs instead of direct axios call
      const response = await templateAPIs.getDynamicVariables({
        payload: { params },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching dynamic variables:", error);

      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  },
);
